// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-product {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  gap: var(--chakra-sizes-1);
  padding: var(--chakra-sizes-1);
  border: var(--chakra-border-widths-3, 3px) solid transparent;
  border-radius: var(--chakra-radii-md);
  box-shadow: var(--chakra-shadows-sm);
  font: inherit;
  text-align: center;
  cursor: pointer;
  transition: filter 0.05s ease-in-out, transform 0.05s ease-in-out;
  appearance: none;
  -webkit-appearance: none;
  user-select: none;
  touch-action: manipulation;
}
.btn-product-sm {
  width: var(--chakra-sizes-15);
  height: var(--chakra-sizes-15);
  padding: var(--chakra-sizes-0\\.5);
}
.btn-product-md {
  width: var(--chakra-sizes-22);
  height: var(--chakra-sizes-22);
}
.btn-product-lg {
  width: var(--chakra-sizes-27);
  height: var(--chakra-sizes-26);
}
.btn-product-phone-md {
  width: var(--chakra-sizes-15);
  height: var(--chakra-sizes-15);
}
.btn-product-phone-lg {
  width: var(--chakra-sizes-20);
  height: var(--chakra-sizes-20);
}
.btn-product-edition.btn-product-sm,
.btn-product-edition.btn-product-phone-md {
  height: var(--chakra-sizes-23);
}
.btn-product-edition.btn-product-md,
.btn-product-edition.btn-product-lg,
.btn-product-edition.btn-product-phone-lg {
  height: var(--chakra-sizes-30);
}
.btn-product:hover {
  filter: brightness(0.95);
}
.btn-product:active {
  transform: scale(0.97);
}
.btn-product:disabled {
  cursor: not-allowed;
  filter: grayscale(1) opacity(0.8);
}
.btn-product-selected {
  border-color: var(--chakra-colors-info);
}
.btn-product-quantity {
  position: absolute;
  top: 1px;
  right: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--chakra-sizes-4\\.5);
  height: var(--chakra-sizes-4\\.5);
  border-radius: var(--chakra-radii-full);
  background: var(--chakra-colors-info);
  color: var(--chakra-colors-white);
  font-size: var(--chakra-font-sizes-2xs);
  font-weight: var(--chakra-font-weights-bold);
}
.btn-product-image-container {
  display: flex;
  align-items: center;
  flex-grow: 1;
  width: var(--chakra-sizes-full);
  border-radius: var(--chakra-radii-sm);
}
.btn-product-image {
  width: var(--chakra-sizes-full);
  height: var(--chakra-sizes-10\\.5);
  aspect-ratio: 1 / 1;
  object-fit: cover;
}
.btn-product-sm .btn-product-image,
.btn-product-phone-md .btn-product-image {
  height: var(--chakra-sizes-8);
}
.btn-product-lg .btn-product-image {
  height: var(--chakra-sizes-13\\.5);
}
.btn-product-phone-lg .btn-product-image {
  height: var(--chakra-sizes-9\\.5);
}
.btn-product-text {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  flex-grow: 1;
  width: var(--chakra-sizes-full);
  max-height: var(--chakra-sizes-full);
  font-size: var(--chakra-font-sizes-xs);
  font-weight: var(--chakra-font-weights-normal);
  line-height: 120%;
  overflow-wrap: anywhere;
  text-wrap: pretty;
}
.btn-product-sm .btn-product-text {
  font-size: var(--chakra-font-sizes-2xs);
  line-height: 110%;
}
.btn-product-phone-md .btn-product-text {
  font-weight: var(--chakra-font-weights-semibold);
}
.btn-product-phone-lg .btn-product-text {
  font-size: var(--chakra-font-sizes-sm);
  font-weight: var(--chakra-font-weights-semibold);
}
.btn-product-has-image .btn-product-text,
.btn-product-edition .btn-product-text {
  overflow: hidden;
}
.btn-product-has-image.btn-product-sm .btn-product-text,
.btn-product-has-image.btn-product-phone-md .btn-product-text,
.btn-product-has-image.btn-product-phone-lg .btn-product-text {
  flex-direction: row;
  text-wrap: nowrap;
}
.btn-product-editor {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  width: var(--chakra-sizes-full);
  min-height: var(--chakra-sizes-6);
  max-height: var(--chakra-sizes-6);
}
.btn-product-editor-actions {
  display: flex;
  justify-content: space-around;
  width: var(--chakra-sizes-full);
  border: var(--chakra-border-widths-1, 1px) solid var(--chakra-colors-neutral-200);
  border-radius: var(--chakra-radii-sm);
  background: var(--chakra-colors-white);
}
.btn-product-editor-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--chakra-sizes-full);
  padding: var(--chakra-sizes-0\\.5);
  color: var(--chakra-colors-neutral-800);
}
.btn-product-editor-action-icon {
  width: var(--chakra-sizes-3\\.5);
  height: var(--chakra-sizes-3\\.5);
}
.btn-product-editor-separator {
  width: var(--chakra-border-widths-1, 1px);
  background: var(--chakra-colors-neutral-200);
}
`, "",{"version":3,"sources":["webpack://./src/pos/css/product-button.less"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,4DAA4D;EAC5D,qCAAqC;EACrC,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iEAAiE;EACjE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;;EAEE,8BAA8B;AAChC;AACA;;;EAGE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;EACvC,qCAAqC;EACrC,iCAAiC;EACjC,uCAAuC;EACvC,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C;EAC9C,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,uCAAuC;EACvC,iBAAiB;AACnB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;AACA;;EAEE,gBAAgB;AAClB;AACA;;;EAGE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,iCAAiC;EACjC,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,iFAAiF;EACjF,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;AACzC;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C","sourcesContent":[".btn-product {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  gap: var(--chakra-sizes-1);\n  padding: var(--chakra-sizes-1);\n  border: var(--chakra-border-widths-3, 3px) solid transparent;\n  border-radius: var(--chakra-radii-md);\n  box-shadow: var(--chakra-shadows-sm);\n  font: inherit;\n  text-align: center;\n  cursor: pointer;\n  transition: filter 0.05s ease-in-out, transform 0.05s ease-in-out;\n  appearance: none;\n  -webkit-appearance: none;\n  user-select: none;\n  touch-action: manipulation;\n}\n.btn-product-sm {\n  width: var(--chakra-sizes-15);\n  height: var(--chakra-sizes-15);\n  padding: var(--chakra-sizes-0\\.5);\n}\n.btn-product-md {\n  width: var(--chakra-sizes-22);\n  height: var(--chakra-sizes-22);\n}\n.btn-product-lg {\n  width: var(--chakra-sizes-27);\n  height: var(--chakra-sizes-26);\n}\n.btn-product-phone-md {\n  width: var(--chakra-sizes-15);\n  height: var(--chakra-sizes-15);\n}\n.btn-product-phone-lg {\n  width: var(--chakra-sizes-20);\n  height: var(--chakra-sizes-20);\n}\n.btn-product-edition.btn-product-sm,\n.btn-product-edition.btn-product-phone-md {\n  height: var(--chakra-sizes-23);\n}\n.btn-product-edition.btn-product-md,\n.btn-product-edition.btn-product-lg,\n.btn-product-edition.btn-product-phone-lg {\n  height: var(--chakra-sizes-30);\n}\n.btn-product:hover {\n  filter: brightness(0.95);\n}\n.btn-product:active {\n  transform: scale(0.97);\n}\n.btn-product:disabled {\n  cursor: not-allowed;\n  filter: grayscale(1) opacity(0.8);\n}\n.btn-product-selected {\n  border-color: var(--chakra-colors-info);\n}\n.btn-product-quantity {\n  position: absolute;\n  top: 1px;\n  right: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--chakra-sizes-4\\.5);\n  height: var(--chakra-sizes-4\\.5);\n  border-radius: var(--chakra-radii-full);\n  background: var(--chakra-colors-info);\n  color: var(--chakra-colors-white);\n  font-size: var(--chakra-font-sizes-2xs);\n  font-weight: var(--chakra-font-weights-bold);\n}\n.btn-product-image-container {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  width: var(--chakra-sizes-full);\n  border-radius: var(--chakra-radii-sm);\n}\n.btn-product-image {\n  width: var(--chakra-sizes-full);\n  height: var(--chakra-sizes-10\\.5);\n  aspect-ratio: 1 / 1;\n  object-fit: cover;\n}\n.btn-product-sm .btn-product-image,\n.btn-product-phone-md .btn-product-image {\n  height: var(--chakra-sizes-8);\n}\n.btn-product-lg .btn-product-image {\n  height: var(--chakra-sizes-13\\.5);\n}\n.btn-product-phone-lg .btn-product-image {\n  height: var(--chakra-sizes-9\\.5);\n}\n.btn-product-text {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  flex-direction: column;\n  flex-grow: 1;\n  width: var(--chakra-sizes-full);\n  max-height: var(--chakra-sizes-full);\n  font-size: var(--chakra-font-sizes-xs);\n  font-weight: var(--chakra-font-weights-normal);\n  line-height: 120%;\n  overflow-wrap: anywhere;\n  text-wrap: pretty;\n}\n.btn-product-sm .btn-product-text {\n  font-size: var(--chakra-font-sizes-2xs);\n  line-height: 110%;\n}\n.btn-product-phone-md .btn-product-text {\n  font-weight: var(--chakra-font-weights-semibold);\n}\n.btn-product-phone-lg .btn-product-text {\n  font-size: var(--chakra-font-sizes-sm);\n  font-weight: var(--chakra-font-weights-semibold);\n}\n.btn-product-has-image .btn-product-text,\n.btn-product-edition .btn-product-text {\n  overflow: hidden;\n}\n.btn-product-has-image.btn-product-sm .btn-product-text,\n.btn-product-has-image.btn-product-phone-md .btn-product-text,\n.btn-product-has-image.btn-product-phone-lg .btn-product-text {\n  flex-direction: row;\n  text-wrap: nowrap;\n}\n.btn-product-editor {\n  display: flex;\n  justify-content: center;\n  flex-grow: 1;\n  width: var(--chakra-sizes-full);\n  min-height: var(--chakra-sizes-6);\n  max-height: var(--chakra-sizes-6);\n}\n.btn-product-editor-actions {\n  display: flex;\n  justify-content: space-around;\n  width: var(--chakra-sizes-full);\n  border: var(--chakra-border-widths-1, 1px) solid var(--chakra-colors-neutral-200);\n  border-radius: var(--chakra-radii-sm);\n  background: var(--chakra-colors-white);\n}\n.btn-product-editor-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--chakra-sizes-full);\n  padding: var(--chakra-sizes-0\\.5);\n  color: var(--chakra-colors-neutral-800);\n}\n.btn-product-editor-action-icon {\n  width: var(--chakra-sizes-3\\.5);\n  height: var(--chakra-sizes-3\\.5);\n}\n.btn-product-editor-separator {\n  width: var(--chakra-border-widths-1, 1px);\n  background: var(--chakra-colors-neutral-200);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
